"use client";
import React, { useState, useEffect } from "react";
import { styled, Container, Box } from "@mui/material";
import {useRouter} from "next/navigation";
import Cookies from 'js-cookie';

const MainWrapper = styled("div")(() => ({
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    padding: "20px",
    backgroundColor: "#e5f3fb",
}));

const PageWrapper = styled("div")(() => ({
    display: "flex",
    flexGrow: 1,
    paddingBottom: "60px",
    flexDirection: "column",
    zIndex: 1,
    backgroundColor: "#e5f3fb",
}));

export default function RootLayout({children}: {
    children: React.ReactNode;
}) {
    const router = useRouter();
    const [isSidebarOpen, setSidebarOpen] = useState(true);
    const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    useEffect(() => {
        if (Cookies.get("bo-auth") !== undefined) {
            router.push("/dashboardlayout");
        }
    }, []);


    return (
        <>
           {children}
        </>
    );
}
